import React, { useCallback, useRef, useState, useEffect,useMemo } from "react";
import { connect } from "react-redux";
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    FilterPanel,
    Paging,
    Editing,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    Selection,
    Toolbar,
    Item,
    RequiredRule,
    StateStoring
} from "devextreme-react/data-grid";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import "jspdf-autotable";
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import { GridLayout } from "../../../../common/GridLayout";
import { IM } from "../../../../const/constants";
const KitDetailTab = (props) => {
    const dataGrid = useRef(null);
    const gridKey = "1DB057BB-6692-4155-A7E4-0252D044F60A";
    var url = "im/ItemKitDetail/GetItemKitDetail";
    const dataSource = useMemo(() => createStore({
        key: 'RowId',
        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
        loadParams:
        {
            HeaderId: props.formFields.RItemKittCode,
            Module: IM
        },
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
                Key: props.sourceId,
            };
        } 
    }), [props.formFields.RItemKittCode]);
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    var accessToken = props.oidc.user.access_token;
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const onContentReady = (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            var selection = e.component.getSelectedRowKeys();
            if (selection.length == 0) {
                e.component.selectRowsByIndexes([0]);
            }
        }
    };
    const handleCellValueChanged = (data) => {
        setSelectedItemKeys(data.selectedRowKeys);
    }
    return (
        <div  >
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                id="gridContainer"
                onContentReady={onContentReady}
                dataSource={dataSource}
                ref={dataGrid}
                selectedRowKeys={selectedItemKeys}
                showBorders={true}
                rowAlternationEnabled={true}
                allowColumnReordering={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                onSelectionChanged={handleCellValueChanged}
                height='71vh'
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                  <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling mode="standard" />
                <Selection mode="single" />
                <Export enabled={true} allowExportSelectedData={true} />

                <Paging enabled={true} defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                    showInfo={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <Column  dataField="ItemCode" caption="Item" dataType="string"    />
                <Column  dataField="Description1" caption="Item Description -1" dataType="string"   />
                <Column  dataField="Quantity" caption="Quantity"  dataType="number" format={{ type: 'fixedPoint', precision: 4, useGrouping: true }}  />
                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc,
        ReceiptReducer: state.ReceiptReducer,
    };
}
export default connect(mapStateToProps)(KitDetailTab);